import { useEffect, useState } from 'react';

const SLIDE_INTERVAL_MS = 6000;
const FADE_MS = 1200;

type Props = {
  images: string[];
  className?: string;
};

export default function HeroBackgroundCarousel({ images, className = '' }: Props) {
  const slides = images.filter(Boolean);
  const [activeIndex, setActiveIndex] = useState(0);
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => setReduceMotion(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  useEffect(() => {
    if (slides.length <= 1 || reduceMotion) return;
    const id = window.setInterval(() => {
      setActiveIndex((i) => (i + 1) % slides.length);
    }, SLIDE_INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [slides.length, reduceMotion]);

  if (slides.length === 0) return null;

  return (
    <div className={`pointer-events-none absolute inset-0 ${className}`.trim()} aria-hidden>
      {slides.map((src, index) => (
        <div
          key={src}
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${src})`,
            opacity: index === activeIndex ? 1 : 0,
            transition: reduceMotion ? 'none' : `opacity ${FADE_MS}ms ease-in-out`,
          }}
        />
      ))}
    </div>
  );
}
